import styled from 'styled-components';

const Actions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.M24};
`;

export { Actions };
